(function () {
    'use strict';

    angular.module("imApp").factory("bspSubService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 3167,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 3168,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
